import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
} from '@chakra-ui/react'
import { leToBr } from '../../utils/Utils'

const styles = StyleSheet.create({
  title: {
    margin: '1em 0em',
    fontSize: '2em',
    fontWeight: 700,
  },
  question: {
    margin: 0,
    fontSize: '1.6em',
    fontWeight: '500',
  },
  iconQuestion: {
    fontWeight: 700,
    fontSize: '2.5em',
    margin: 0,
  },
  containerQuestions: {
    margin: '0em 45em 0em 2em',
  },
  accord: {
    display: 'flex',
    height: '500px',
    width: '80vw',
    flexWrap: 'nowrap',
    flexDirection: 'column',
    margin: '0px 10% 0px 10%',
    borderColor: 'white',
    paddingBottom: '40px',
    gap: '10px',
    '@media (max-width: 480px)': {
      height: 'auto',
    },
  },
  box: {
    outline: '0px solid',
    borderColor: 'transparant',
  },
  QuestionsAnswers: {
    paddingLeft: '15px',
  },
})

const QuestionsAnswers = () => {
  const { t } = useTranslation('translation')

  const listQuestions = [
    t('pages.beAMaker.question1'),
    t('pages.beAMaker.question2'),
    t('pages.beAMaker.question3'),
    t('pages.beAMaker.question4'),
    t('pages.beAMaker.question5'),
    t('pages.beAMaker.question6'),
  ]
  const listAnswers = [
    leToBr(t('pages.beAMaker.answer1')),
    leToBr(t('pages.beAMaker.answer2')),
    leToBr(t('pages.beAMaker.answer3')),
    leToBr(t('pages.beAMaker.answer4')),
    leToBr(t('pages.beAMaker.answer5')),
    leToBr(t('pages.beAMaker.answer6')),
  ]

  return (
    <div id="question">
      <Accordion className={css(styles.accord)}>
        <h2 className={css(styles.title)}>
          {t('pages.beAMaker.titleQuestionsAnswers')}
        </h2>
        {listQuestions.map((question, index) => (
          <>
            <AccordionItem>
              {({ isExpanded }) => (
                <>
                  <AccordionButton
                    borderColor="transparent"
                    backgroundColor={'white'}
                  >
                    <Box
                      flex="1"
                      textAlign="left"
                      className={css(styles.question)}
                    >
                      {question}{' '}
                    </Box>
                    {isExpanded ? (
                      <span className={css(styles.iconQuestion)}>-</span>
                    ) : (
                      <span className={css(styles.iconQuestion)}>+</span>
                    )}
                  </AccordionButton>
                  <AccordionPanel
                    pb={4}
                    className={css(styles.QuestionsAnswers)}
                  >
                    {listAnswers && listAnswers.at(index)}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          </>
        ))}
      </Accordion>
    </div>
  )
}

export default QuestionsAnswers
